// Links de download do app do entregador (Leo Go).
// Os valores vêm de variáveis de ambiente injetadas no build pelo CI/CD.
// Em produção, defina-as como "Variables" no GitHub (ver README/CI).
// Enquanto o valor não estiver definido, o botão aparece como "Em breve".

export const DRIVER_PLAY_STORE_URL = process.env.REACT_APP_DRIVER_PLAY_STORE_URL || '';
export const DRIVER_APP_STORE_URL = process.env.REACT_APP_DRIVER_APP_STORE_URL || '';

export const driverAppLinks = {
  playStore: DRIVER_PLAY_STORE_URL,
  appStore: DRIVER_APP_STORE_URL,
};
